import { Reveal, SectionTitle } from "./Reveal";
import { CONTACT } from "../../content";
import { useT } from "../../i18n/LangContext";

const IMG = { airport: "/airport.webp", long: "/hero-coast.webp", minibus: "/minibus.webp", north: "/north.webp", business: "/business.webp" };
const SPAN = ["lg:col-span-3", "lg:col-span-3", "lg:col-span-2", "lg:col-span-2", "md:col-span-2 lg:col-span-2"];

const Card = ({ s, t }) => (
  <article id={s.id} className="flex h-full scroll-mt-24 justify-between gap-4 rounded-xl bg-[#F3F3F3] p-5 transition-colors hover:bg-[#EAEAEA]" data-testid={`service-${s.id}`}>
    <div className="flex flex-col">
      <h3 className="text-lg font-bold text-black">{s.title}</h3>
      <p className="mb-4 mt-1.5 text-sm leading-relaxed text-zinc-600">{s.text}</p>
      <a
        href={`${CONTACT.whatsapp}?text=${encodeURIComponent(t.bookMsg + s.title)}`}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-auto w-fit rounded-full bg-black px-4 py-1.5 text-sm font-medium text-white transition-colors hover:bg-zinc-800"
        data-testid={`service-details-${s.id}`}
      >
        {t.details}
      </a>
    </div>
    <img src={IMG[s.id]} alt="" loading="lazy" className="h-20 w-20 shrink-0 rounded-lg object-cover sm:h-24 sm:w-24" />
  </article>
);

export const Services = () => {
  const t = useT().services;
  return (
    <section id="services" className="scroll-mt-16 bg-white px-5 py-16 sm:px-8 lg:py-20" data-testid="services-section">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <SectionTitle>{t.title}</SectionTitle>
        </Reveal>
        <div className="mt-8 grid gap-4 md:grid-cols-2 lg:grid-cols-6">
          {t.items.map((s, i) => (
            <Reveal key={s.id} delay={(i % 3) * 0.06} className={SPAN[i]}>
              <Card s={s} t={t} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
